import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=2654d8ad&scoped=true&"
import script from "./GlobalLoader.vue?vue&type=script&lang=js&"
export * from "./GlobalLoader.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=2654d8ad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2654d8ad",
  null
  
)

export default component.exports